import axiosOpenClient from "api/axiosOpenClient";

export const getProductPlans = async () => {
  try {
    const response = await axiosOpenClient.get("/public/api/product-plans");
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
